const CitySuggestion = function (opts) {
    this.input_type = 'charcoal/admin/property/input/selectize/CitySuggestion';
    Charcoal.Admin.Property_Input_Selectize.call(this, opts)
}

CitySuggestion.prototype = Object.create(Charcoal.Admin.Property_Input_Selectize.prototype);
CitySuggestion.constructor = Charcoal.Admin.Property_Input_Selectize;
CitySuggestion.parent = Charcoal.Admin.Property_Input_Selectize.prototype;

CitySuggestion.prototype.load_from_remote = function (query, callback) {
    if (!query.length) {
        return callback();
    }

    const data = {
        sql: `SELECT * FROM "19385b4e-5503-4330-9e59-f998f5918363" WHERE LOWER(munnom) LIKE LOWER('%${query}%') LIMIT 10`
    }

    $.ajax({
        url: 'https://www.donneesquebec.ca/recherche/api/3/action/datastore_search_sql',
        data: data,
        dataType: 'json',
        success: function(data) {
            if (!data.success) {
                callback([]);
                return;
            }

            const records = data.result.records;

            if (typeof records !== 'object' || !records.length) {
                callback([]);
                return;
            }

            const results = records.map(function(record) {
                let territory;
                if (record.mrc) {
                    territory = record.mrc.match(new RegExp(/\(([0-9]*)\)/))[1]
                } else if (record.divrec) {
                    territory = record.divrec.match(new RegExp(/\(([0-9]*)\)/))[1] + '0'
                }

                return {
                    label: record.munnom,
                    value: record.munnom,
                    territory: territory,
                }
            })

            callback(results)
        }
    });
}

CitySuggestion.prototype.set_properties = function (opts) {
    this.remote_source = true

    Charcoal.Admin.Property_Input_Selectize.prototype.set_properties.call(this, opts);

    this.selectize_options.onChange = function (value) {
        if (this.options[value]) {
            // Update the field "mrc" automatically
            // This is for the candidate model, not sure if this can cause problems elsewhere.
            $('select[name="mrc"]').val(this.options[value].territory).change();
        }
    }

    return this;
}

Charcoal.Admin.Property_Input_Selectize_CitySuggestion = CitySuggestion;
